/**
 * Console view-mode hook.
 *
 * Two modes:
 *  - "client"   → Client Briefing View (default; client-facing 6 tabs)
 *  - "operator" → Operator View (full 10-tab engineering console)
 *
 * Persisted to localStorage; broadcast via a window event so multiple
 * components (ConsoleShell header + workspace sidebar) stay in sync without
 * a context provider.
 */
import { useEffect, useState } from "react";

const KEY = "v2e_console_mode";
const EVENT = "v2e-mode-change";

export const MODE_CLIENT = "client";
export const MODE_OPERATOR = "operator";

function readMode() {
  try {
    const v = localStorage.getItem(KEY);
    return v === MODE_OPERATOR ? MODE_OPERATOR : MODE_CLIENT;
  } catch {
    return MODE_CLIENT;
  }
}

export function useConsoleMode() {
  const [mode, setModeState] = useState(readMode);

  useEffect(() => {
    const handler = (e) => setModeState(e.detail);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  const setMode = (next) => {
    const m = next === MODE_OPERATOR ? MODE_OPERATOR : MODE_CLIENT;
    try { localStorage.setItem(KEY, m); } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: m }));
  };

  return [mode, setMode];
}
